import React from "react";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";

export default function LocationActive({ active, setActive }) {
  const toggleActive = value => {
    setActive(v => (typeof v === "boolean" && v === value ? null : value));
  };

  return (
    <Box>
      <MenuItem sx={{ fontSize: 14 }} onClick={() => toggleActive(true)}>
        <Box my={-1} ml={-1}>
          <Checkbox checked={active === true} value="" />
        </Box>
        Yes
      </MenuItem>
      <MenuItem sx={{ fontSize: 14 }} onClick={() => toggleActive(false)}>
        <Box my={-1} ml={-1}>
          <Checkbox checked={active === false} value="" />
        </Box>
        No
      </MenuItem>
    </Box>
  );
}


